export enum FeedItemSort {
  New = 'New',
  Relevance = 'Relevance',
  TopAllTime = 'TopAllTime',
}
